export default {
  title: "غير مصرح",
  description: `<p>تم رفض الوصول. ليس لديك إذن لعرض هذه الصفحة.</p>
            <p>إذا كنت تعتقد أن هذه خطأ، يرجى الاتصال بالدعم.</p>`,
};
